import React, { useEffect, useState } from 'react'
import MainContentWrapper from '../../Components/MainContentWrapper'
import { PDRL_ADMIN_ROUTES } from '../../routes'
import DashBoardCard from '../../features/HomePage/SubComponents/DashBoardCard/DashBoardCard'
import { getCrmDashboardOverViewData } from '../../apis/BhuMeetTeams/Crm/overview'

const CrmDashBoard = () => {

    const [overview,setOverview] = useState()

    useEffect(() => {

        overviewDataAPI()

        
    }, [])

    const overviewDataAPI = async()=>{

        const count = await getCrmDashboardOverViewData()
        setOverview(count)
    }

    return <MainContentWrapper>
        <div className="dashboard-first-section-second-div" style={{ width: "100%" }} >
            <div className="dashboard-first-section-second-div-one" style={{
      display: "grid",
      gridTemplateColumns: "repeat(5, minmax(200px, 1fr))",
      gap: "17px",
    }} >


                <DashBoardCard
                    loading={false}
                    title="Leads"
                    data={overview?.total_leads || 0}
                    // icon={droneCardIcon}
                    view={PDRL_ADMIN_ROUTES.CRMLEADS}
                />

                
            </div>
        </div>
    </MainContentWrapper>
}

export default CrmDashBoard